<template>
  <!--云课堂-->
  <div class="view">
    <el-row>
      <el-col :span="12">
        <div class="img">
          <img class="imgLeft" src="../../../assets/competition/view/zuocewenzi-03.svg"/>
        </div>
      </el-col>
      <el-col :span="12">
        <div>
          <img class="imgRight" src="../../../assets/competition/view/cahtu-03.svg"/>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
  }
</script>
<style scoped>
  .view {
    width: 100%;
    height: 100vh;
    background-color: #b38a40;
  }

  .img {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .imgLeft {
    margin-top: 180px;
  }

  .imgRight {
    margin-top: 100px;
  }

</style>
